import axios from "axios";

export class LootBoxService {
  private settingsUrl: string;
  private fetchUrl?: string;
  private controller: AbortController | null;
  private settingsUpdateIntervalInMinutes: number = 30;

  constructor(settingsUrl: string) {
    this.settingsUrl = settingsUrl;
    this.controller = null;
  }

  async init(): Promise<void> {
    await this.updateSettings();
  }

  async start(): Promise<void> {
    this.controller = new AbortController();
    try {
      await this.fetch("/start", this.controller.signal);
    } catch (error: any) {
      if (error.message !== "canceled") {
        console.log("/start: error during the loop", error);
      }
    }
  }

  async draw(): Promise<void> {
    try {
      await this.fetch("/draw");
    } catch (error) {
      console.log("/draw: error during the draw:", error);
    }
  }

  cancel(): void {
    if (this.controller) {
      this.controller.abort();
      this.controller = null;
    }
  }

  private async fetch(path: string, signal?: AbortSignal): Promise<void> {
    if (this.fetchUrl === undefined) {
      return;
    }

    await axios({
      method: "GET",
      url: this.fetchUrl + path,
      signal,
    });
  }

  private async updateSettings(): Promise<void> {
    try {
      const { data } = await axios({
        method: "GET",
        url: this.settingsUrl,
      });

      this.fetchUrl = data.response.host;
    } catch (error) {
      // ignore, will wait again later and use old settings in the meanwhile
    }

    this.queueNextSettingsUpdate();
  }

  private queueNextSettingsUpdate(): void {
    setTimeout(
      () => this.updateSettings(),
      this.settingsUpdateIntervalInMinutes * 60 * 1000
    );
  }
}
